const Menu = [
  { header: 'Applicatie'},
  {
    title: 'Home',
    group: 'pas',
    icon: 'far fa-home',
    name: 'Home',
    permission:'ui_home'
  },
  { header: 'Assets'},
  {
    title: 'Asset kaart',
    group: 'apps',
    icon: 'far fa-map-marker-alt',
    name: 'AssetMap',
    permission:'ui_asset_map'
  },
  {
    title: 'Overzicht',
    group: 'apps',
    icon: 'far fa-list-alt',
    name: 'AssetOverview',
    permission:'ui_asset_overview'
  },
  {
    title: 'Locatieoverzicht',
    group: 'apps',
    icon: 'far fa-layer-group',
    name: 'PoiOverview',
    permission:'ui_location_overview'
  },
  {
    title: 'Meldingen',
    group: 'apps',
    icon: 'far fa-comment-alt-lines',    
    name: 'NotificationCenter',
    permission:'ui_notifications'
  },
  {
    title: 'Rapportages',
    group: 'apps',     
    icon: 'far fa-clipboard-list',
    permission:'ui_reports',    
    items: [
      { 
        title: 'Inzetrapportage',         
        name: 'DeploymentReport', 
        icon: 'linear_scale',   
        permission:'ui_reports',                     
      },
      { 
        title: 'Tijd in zone',         
        name: 'AssetGroups', 
        icon: 'linear_scale',       
        permission:'ui_reports',                 
      },
      { 
        title: 'Stilstand',         
        name: 'AssetGroups', 
        icon: 'linear_scale',       
        permission:'ui_reports',                 
      },
    ]
    
  },
  {
    title: 'Media',
    group: 'apps',
    name: 'Media',
    icon: 'far fa-images',
    permission:'ui_media'
  },
  { 
    title: 'Points of interest',         
    name: 'ManageGeoZonesMap', 
    icon: 'linear_scale',           
    permission:'ui_geo_zone_manager'         
  },     
/*  
  { header: 'Fleet'},
  {
    title: 'Live',
    group: 'apps',
    name: 'Live',
    icon: 'map',
  },
  {
    title: 'Wagenpark',
    group: 'apps',
    name: 'Wagenpark',
    icon: 'directions_car',
  },
  {
    title: 'Ritregistratie',
    group: 'apps',
    name: 'Ritreg',
    icon: 'directions',
  },
  {
    title: 'Rijgedrag',
    group: 'apps',
    name: 'RGD',
    icon: 'assignment_ind',
  },
  */
  { header: 'Instellingen',
    visibleFor:['administrator']
  },
  {
    title: 'Gebruikers',
    group: 'settings',
    name: 'Users',
    icon: 'far fa-user-circle',
    permission:'ui_user_manager'
  },  
  {
    title: 'Gebruikersrollen',
    group: 'settings',
    name: 'UserRoles',
    icon: 'far fa-users',
    permission:'ui_user_roles'
  },    
  {
    title: 'Instellingen',
    group: 'settings',
    icon: 'far fa-tools',
    visibleFor:['administrator'],
    items: [
      { 
        title: 'Assets',         
        name: 'Assets', 
        icon: 'linear_scale',     
        permission: 'ui_asset_manager'               
      },
      { 
        title: 'Asset groepen',         
        name: 'AssetGroups', 
        icon: 'linear_scale',      
        permission:'ui_asset_groups'              
      },
      { 
        title: 'Asset soorten',         
        name: 'AssetTypes', 
        icon: 'linear_scale',     
        permission:'ui_asset_types'               
      },      
      { 
        title: 'Hardware types',         
        name: 'UnitTypes', 
        icon: 'linear_scale',       
        permission:'ui_unit_type_manager'             
      },     
      { 
        title: 'Extra velden',         
        name: 'CustomFields', 
        icon: 'linear_scale',        
        permission:'ui_custom_field_manager'            
      },          
      { 
        title: 'POI types',         
        name: 'ManageGeoZoneTypes', 
        icon: 'linear_scale',         
        permission:'ui_geo_zone_type_manager'           
      },
      { 
        title: "Tijdschema's",         
        name: 'TimeTables', 
        icon: 'linear_scale',       
        permission:'ui_time_table_manager'             
      },               
    ]
  },
  { header: 'Development',  visibleFor:['deepdigital']},
  {
    title: 'Albatros Debug',
    group: 'apps',
    name: 'AlbatrosDebug',
    icon: 'far fa-bug',
    permission:'ui_albatros_debug'
  },
]
export default Menu;
